import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {DataSource} from '@mominsamir/ngx-smart-table/lib/lib/data-source/data-source';
import {LatestModelStatus} from '@core/interfaces/live/live';
import {Filter} from '@core/interfaces/system/system-common';
import {
    VegClearanceClearanceData,
    VegClearanceLastTrimData,
    VegClearanceService,
    VegClearanceUnits,
} from '@core/interfaces/live/veg-clearance';
import {VegClearanceApi} from '@core/backend/engin/api/live/veg-clearance.api';

@Injectable()
export class VegClearanceServiceImpl extends VegClearanceService {
    constructor(private api: VegClearanceApi) {
        super();
    }

    public getVegClearanceUnits(): Observable<VegClearanceUnits> {
        return this.api.getVegClearanceUnits();
    }

    public getVegClearanceDatasource(id: string, filters: Filter[]): Observable<DataSource> {
        return this.api.getVegClearanceDatasource(id, filters);
    }

    public getCountResults(id: string, uploadDate?: string): Observable<number> {
        return this.api.getCountResults(id, uploadDate);
    }

    public getVegClearanceLatestModelStatus(id: string, uploadDate?: string): Observable<LatestModelStatus> {
        return this.api.getVegClearanceLatestModelStatus(id, uploadDate);
    }

    public getVegClearanceClearanceData(id: string, uploadDate?: string): Observable<VegClearanceClearanceData> {
        return this.api.getVegClearanceClearanceData(id, uploadDate);
    }

    public getVegClearanceLastTrimData(id: string, uploadDate?: string): Observable<VegClearanceLastTrimData> {
        return this.api.getVegClearanceLastTrimData(id, uploadDate);
    }
}
